<template>
  <template v-if="item?.isComment === 1">
    <div class="product-comment">
      <div class="comment-content">
        <div class="block">
          <div class="comment-row">
            <div class="row-label horizontal c-muli-semibold">
              {{ $t("Score") }}:
            </div>
            <div class="row-value horizontal">
              <c-rate
                size="large"
                :model-value="
                  item.productReview.rateNum || item.productReview.rating
                "
                readonly
                gutter="3"
              />
            </div>
          </div>
          <!-- <div class="comment-row">
            <div class="row-label c-muli-semibold">{{ $t("Title") }}:</div>
            <div class="row-value c-muli-light">
              {{ item.productReview.title }}
            </div>
          </div> -->
          <div class="comment-row">
            <div class="row-label c-muli-semibold">{{ $t("Review") }}:</div>
            <div class="row-value c-muli-light">
              {{ item.productReview.content }}
            </div>
          </div>
          <div class="comment-row" v-if="item.productReview.medias?.length">
            <div class="row-label c-muli-semibold">
              {{ $t("Media") }}( {{ item.productReview.medias?.length }} /
              {{ max_file }} ):
            </div>
            <div class="row-value">
              <template
                v-for="media in item.productReview.medias"
                :key="media.id"
              >
                <img
                  v-if="media.type === 0"
                  class="prd-img"
                  :src="media.cdnLink"
                  alt=""
                />
                <video
                  class="prd-img"
                  :src="media.cdnLink"
                  v-if="media.type === 1"
                  controls="controls"
                />
              </template>
            </div>
          </div>
          <div class="comment-row" v-if="item.fileList?.length">
            <div class="row-label c-muli-semibold">
              {{ $t("Media") }}( {{ item.fileList?.length }} / {{ max_file }} ):
              <span>{{ $t("MediaReward") }}</span>
            </div>
            <div class="row-value">
              <c-image
                class="prd-img"
                :src="file.content"
                v-for="(file, index) in item.fileList"
                :key="index"
                alt=""
              />
            </div>
          </div>
        </div>
        <div
          class="block"
          v-if="
            item.productReview.qas?.filter((i) => Boolean(i.answer))?.length
          "
        >
          <template v-for="(qa, index) in item.productReview.qas" :key="index">
            <div class="comment-row" v-if="qa.answer">
              <div class="row-label c-muli-semibold">{{ qa.title }}:</div>
              <div class="row-value c-muli-light">{{ qa.answer }}</div>
            </div>
          </template>
        </div>
        <div class="block next">
          <c-button type="primary" block @click="$emit('next')">{{
            $t("next")
          }}</c-button>
        </div>
      </div>
      <div class="tri"></div>
    </div>
  </template>
  <template v-else>
    <div
      class="absolute top-0 left-0 right-0 z-2"
      id="voice-position-container"
    ></div>
    <div class="product-form">
      <div class="items">
        <FormItem
          @change="onChange(formItem, $event)"
          v-for="formItem in state.formItems"
          :key="formItem.name"
          :item="formItem"
          :product="item"
        />
        <div class="form-item">
          <div class="form-label c-muli-semibold">
            {{ $t("Media") }}: ( {{ state.fileList.length }} / {{ max_file }} )
            <span
              style="color: #f2a634; margin-left: 4px; font-size: 12px"
              v-if="state.mediaActivity"
            >
              {{ $t("MediaReward") }}
            </span>
          </div>
          <div
            v-for="(file, index) in state.fileList"
            :key="index"
            :style="{
              display: 'inline-block',
              marginRight: '16px',
              marginBottom: '16px',
              position: 'relative',
              width: isMobile ? 108 : 128,
              height: isMobile ? 108 : 128,
              verticalAlign: 'top',
            }"
          >
            <video
              v-if="file.file.type === 'video/mp4'"
              style="cursor: pointer"
              :src="file.src"
              :width="isMobile ? 108 : 128"
              :height="isMobile ? 108 : 128"
            />
            <c-image
              v-else
              fit="cover"
              :src="file.content || file.url"
              :width="isMobile ? 108 : 128"
              :height="isMobile ? 108 : 128"
            />
            <div
              v-if="file.file.type === 'video/mp4'"
              style="
                position: absolute;
                text-align: center;
                top: 50%;
                left: 50%;
                width: 32px;
                height: 32px;
                border-radius: 50%;
                cursor: pointer;
                transform: translate(-50%, -50%);
                border: 1px solid #fff;
                background-color: rgba(0, 0, 0, 0.4);
                line-height: 32px;
              "
            >
              <c-icon name="play" size="16" color="white" />
            </div>
            <div
              style="
                cursor: pointer;
                width: 24px;
                height: 24px;
                position: absolute;
                line-height: 24px;
                top: 0;
                right: 0;
                text-align: center;
                background-color: rgba(0, 0, 0, 0.6);
              "
              @click="state.fileList.splice(index, 1)"
            >
              <c-icon name="close" size="18" color="#fff" />
            </div>
          </div>
          <c-uploader
            v-if="state.fileList.length < max_file"
            :max-count="1"
            :model-value="[]"
            accept="image/jpeg,image/jpg,image/png,video/mp4"
            :before-read="beforeRead"
            @update:model-value="onUpload"
          />
          <div style="font-family: Muli; font-size: 12px; color: #666">
            {{ $t("MediaType") }}
          </div>
        </div>
        <div
          class="form-item"
          style="cursor: pointer"
          v-if="!state.expanded && state.qas.length"
          @click="state.expanded = !state.expanded"
        >
          <div class="form-label c-muli-semibold">
            {{ state.qaActivity ? $t("RewardQa") : $t("MoreQa") }}
            <img
              v-if="state.qaActivity"
              src="../assets/comment_award.png"
              alt=""
              style="
                width: 16px;
                height: 16px;
                vertical-align: text-top;
                margin-right: 8px;
              "
            />
            <c-icon style="vertical-align: middle" name="arrow_down" />
          </div>
        </div>
      </div>
      <div class="qas" v-if="state.qas.length && state.expanded">
        <FormItem
          @change="onChange(qa, $event)"
          v-for="qa in state.qas"
          :key="qa.name"
          :item="qa"
          :product="item"
        />
      </div>
      <div class="submit">
        <c-button
          type="primary"
          block
          @click="onSubmit"
          cover
          :loading="loading"
        >
          {{ $t("POST") }}
        </c-button>
      </div>
      <div class="tri"></div>
    </div>
  </template>
</template>

<script setup>
import {
  reactive,
  defineProps,
  defineEmits,
  watch,
  onMounted,
  computed,
} from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import FormItem from "./form-item.vue";
import { queryDynamicQas, queryActivitySign } from "../service";

const props = defineProps({
  item: Object,
  activeIndex: Number,
  loading: Boolean,
});

const isMobile = computed(() => window.innerWidth <= 768);

const emit = defineEmits(["comment", "next"]);

const { t } = useI18n();

const max_file = 6;

const route = useRoute();

watch(
  () => props.item,
  () => {
    getQas();
    clear();
    state.fileList = [];
  }
);

const state = reactive({
  expanded: false,
  mediaActivity: false,
  qaActivity: false,
  formItems: [
    {
      name: "rating",
      horizontal: true,
      required: true,
      type: "rate",
      label: t("Score") + ":",
      value: 0,
      error: false,
      errText: "",
      emptyErr: t("Please enter a star rating for this review"),
    },
    // {
    //   name: "title",
    //   required: true,
    //   label: t("Title") + ":",
    //   type: "input",
    //   value: "",
    //   error: false,
    //   errText: "",
    //   emptyErr: t("Review’s title can’t be empty"),
    // },
    {
      name: "content",
      required: true,
      label: t("Review") + ":",
      type: "textarea",
      rows: 1,
      maxlength: 500,
      value: "",
      error: false,
      errText: "",
      emptyErr: t("Review’s body can’t be empty"),
    },
  ],
  fileList: [],
  qas: [],
});

const clear = () => {
  state.formItems.forEach((i) => {
    if (i.type === "rate") {
      i.value = 0;
    } else if (i.type === "input" || i.type === "textarea") {
      i.value = "";
    }
    i.error = false;
  });
  state.qas.forEach((i) => {
    i.value = i.inputType === 2 ? [] : "";
  });
};

const getQas = async () => {
  const { siteId, brandId, terminalId, channelId } = route.query;
  const param = {
    siteId,
    brandId,
    terminalId,
    channelId,
    lang: t("lang"),
    langCode: t("langCode"),
  };
  const res = await queryDynamicQas(param);
  const data = res.data.data.list;
  const qas = data.map((i) => ({
    ...i,
    required: false,
    label: i.question,
    name: i.title,
    type: i.inputType,
    options: i.options,
    value: i.inputType === 2 ? [] : "",
  }));
  state.qas = qas;
};

const beforeRead = (file) => {
  if (file.type.indexOf("image") != -1 && file.size >= 10485760) {
    alert(t("Please upload a media less than 10 megabytes"));
    return false;
  }

  if (file.type.indexOf("video") != -1 && file.size >= 20971520) {
    alert(t("Please upload a media less than 20 megabytes"));
    return false;
  }

  return true;
};

const onSubmit = () => {
  state.formItems.forEach((item) => {
    if (item.required && !item.value) {
      item.error = true;
      item.errText = item.emptyErr;
    }
  });

  let hasError;

  state.formItems.forEach((item) => {
    if (item.error) {
      hasError = true;
      document
        .querySelectorAll(`.form-item[data-name=${item.name}]`)[0]
        ?.scrollIntoView({ behavior: "smooth", block: "center" });

      return;
    }
  });

  if (hasError) return;

  const param = {
    productId: props.item.skuDetail.productId,
    productName: props.item.skuDetail.title,
    src: props.item.skuDetail.imageSrc,
    sku: props.item.skuCode,
    skcCode: props.item.skuDetail.skcCode,
    linkShopify: `https://${t("siteName")}.cupshe.com/products/${
      props.item.skuDetail.jumpPath
    }`,
  };

  const productReview = {
    qas: [],
  };

  state.formItems.forEach((item) => {
    param[item.name] = item.value;
    productReview[item.name] = item.value;
  });

  state.qas.forEach((qa) => {
    let answer = "";
    if (qa.type === 2) {
      answer = qa.value.join(", ");
    } else {
      answer = qa.value;
    }

    if (answer) {
      productReview.qas.push({ title: qa.title, answer });
    }

    param[`qas[${qa.sortNum - 1}].question`] = qa.question;
    param[`qas[${qa.sortNum - 1}].answer`] = answer;
    param[`qas[${qa.sortNum - 1}].privacy`] = qa.privacy;
    param[`qas[${qa.sortNum - 1}].questionId`] = qa.id;
    param[`qas[${qa.sortNum - 1}].sortNum`] = qa.sortNum;
    param[`qas[${qa.sortNum - 1}].title`] = qa.title;
  });

  param.productReview = productReview;

  emit("comment", props.activeIndex, param, state.fileList);
};

const onChange = (item, value) => {
  item.value = value;
  item.error = false;
};

const onUpload = (file) => {
  if (file[0].file.type === "video/mp4") {
    file[0].src = URL.createObjectURL(file[0].file);
  }
  state.fileList.push(file[0]);
};

const getActivity = async () => {
  const { siteId, brandId, terminalId, channelId } = route.query;
  const { data } = await queryActivitySign({
    siteId,
    brandId,
    terminalId,
    channelId,
    lang: t("lang"),
    langCode: t("langCode"),
  });
  state.mediaActivity = data.data.mediaActivity;
  state.qaActivity = data.data.qaActivity;
};

onMounted(() => {
  getActivity();
});
</script>

<style lang="less">
.product-form {
  position: relative;
  .form-item {
    .form-label {
      margin-right: 6px;
      margin-bottom: 8px;
      font-size: 14px;
      line-height: 18px;
      color: #333;
      vertical-align: text-bottom;

      &.required::before {
        color: #e61717;
        content: "*";
      }

      &.horizontal {
        display: inline-block;
        line-height: 24px;
        margin-bottom: 0;
      }
    }

    .form-item-err {
      margin-top: 2px;
      font-size: 12px;
      line-height: 20px;
      color: #ec4e4e;

      @media (max-width: 768px) {
        margin-bottom: 24px;
      }

      @media (min-width: 769px) {
        margin-bottom: 20px;
      }
    }

    .form-input {
      width: 600px;

      @media (max-width: 768px) {
        width: 100%;
      }
    }

    @media (max-width: 768px) {
      &:not(:last-child) {
        margin-bottom: 24px;
      }

      .c-uploader__preview-image,
      .c-uploader__upload {
        width: 108px !important;
        height: 108px !important;
      }
    }

    .c-uploader__preview-delete:hover {
      background: #000 !important;
    }

    @media (min-width: 769px) {
      &:not(:last-child) {
        margin-bottom: 20px;
      }
    }
  }

  .items {
    @media (max-width: 768px) {
      background: #fff;
      padding: 32px 18px 24px;
      border-bottom: 1px solid #f2f2f2;
    }

    @media (min-width: 769px) {
      border-bottom: 1px solid #f2f2f2;
    }
  }

  .qas {
    @media (max-width: 768px) {
      background: #fff;
      padding: 24px 18px;
    }

    @media (min-width: 769px) {
      margin-top: 24px;
      border-bottom: 1px solid #f2f2f2;
    }
  }

  .submit {
    @media (max-width: 768px) {
      background: #fff;
      padding: 24px 18px;
      border-top: 1px solid #f2f2f2;
    }

    @media (min-width: 769px) {
      margin-top: 24px;
    }

    button {
      height: 44px;
      font-size: 14px;
      text-transform: uppercase;
    }
  }

  @media (max-width: 768px) {
    margin-top: 40px;
    background: #fafafa;
    padding: 16px;

    .tri {
      position: absolute;
      width: 0;
      height: 0;
      top: -22px;
      left: 50%;
      transform: translateX(-50%);
      border-left: 13.5px solid transparent;
      border-right: 13.5px solid transparent;
      border-bottom: 16px solid #fafafa;
    }
  }

  @media (min-width: 769px) {
    width: 656px;
    margin: 42px auto 100px;
    padding: 40px 72px;
    background: #fafafa;
  }
}

.product-comment {
  position: relative;
  @media (max-width: 768px) {
    margin-top: 40px;
    padding: 16px;
    background: #fafafa;

    .comment-content {
      background: #fff;

      .block {
        padding: 24px 18px;
        &:not(:first-child) {
          border-top: 1px solid #f2f2f2;
        }

        &.next {
          text-transform: uppercase;
        }

        .comment-row {
          .row-label {
            font-size: 14px;
            line-height: 18px;
            color: #333;
            margin-right: 12px;
            margin-bottom: 8px;

            &.horizontal {
              display: inline-block;
              line-height: 24px;
              margin-bottom: 0;
              vertical-align: text-bottom;
            }
          }

          .row-value {
            font-size: 12px;
            line-height: 15px;
            color: #333;

            .prd-img {
              width: 90px;
              height: 90px;
              margin-right: 12px;
              margin-bottom: 8px;
              object-fit: cover;
            }

            &.horizontal {
              display: inline-block;
            }
          }

          &:not(:last-child) {
            margin-bottom: 24px;
          }
        }

        button {
          height: 44px;
          font-size: 14px;
          text-transform: uppercase;
        }
      }
    }

    .tri {
      position: absolute;
      width: 0;
      height: 0;
      top: -16px;
      left: 50%;
      transform: translateX(-50%);
      border-left: 13.5px solid transparent;
      border-right: 13.5px solid transparent;
      border-bottom: 16px solid #fafafa;
    }
  }

  @media (min-width: 769px) {
    width: 744px;
    margin: 42px auto 100px;
    padding: 16px 28px;
    background: #fafafa;

    .comment-content {
      .block {
        padding: 24px 0;

        &.next {
          display: none;
        }

        &:not(:first-child) {
          border-top: 1px solid #f2f2f2;
        }

        .comment-row {
          display: flex;

          .row-label {
            margin-right: 20px;
            text-align: right;
            flex-basis: 140px;
            font-size: 14px;
            line-height: 18px;
            color: #333;

            &.horizontal {
              line-height: 26px;
            }
          }

          .row-value {
            flex: 1;
            max-width: 544px;
            word-break: break-word;
            font-size: 14px;
            line-height: 21px;

            .prd-img {
              width: 128px;
              height: 128px;
              margin-right: 8px;
              object-fit: cover;
            }
          }

          &:not(:last-child) {
            margin-bottom: 24px;
          }
        }
      }
    }
  }
}
</style>
